<template>
    <rkm-overlay>
        <rkm-layout-body title="Lista de supervisor">
            <template v-slot:actions>
                <rkm-button
                    @click="$router.push({ name: 'transporte-paciente-supervisor-create' })"
                    autorize="store-transporte-paciente-supervisor"
                    color="primary"
                >
                    Cadastrar supervisor
                </rkm-button>
            </template>

            <rkm-layout-content>
                <List />
            </rkm-layout-content>
        </rkm-layout-body>
    </rkm-overlay>
</template>

<script>

// Components.
import List from '@/components/transporte-paciente/supervisor/List'

export default {
    components: { List },
}
</script>